import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import AuthService from '../../../services/authService';
import { emptyReduxStore } from '../../../redux/actions/index';

interface LoginProps {
    emptyReduxStore: Function;
}

const Login: React.FC<LoginProps> = (props: LoginProps): JSX.Element => {
    props.emptyReduxStore();

    return AuthService.login(props);
};

export default withRouter(connect(null, { emptyReduxStore })(Login));
